// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__212uA","label":"LabeledBox_label__SFP_X"};